import { ForwardedRef, forwardRef, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useMergeRefs } from '@xemplo/ref-utils';

import { FieldProps, useTextDropdownMultiRhf } from './hooks/use-multi-select-rhf';
import { TextDropdownMulti } from './text-dropdown-multi';
import { TextDropdownMultiRhfProps } from './text-dropdown-multi.types';

export const TextDropdownMultiRhf = forwardRef(
  (props: TextDropdownMultiRhfProps, ref?: ForwardedRef<HTMLDivElement>) => {
    const { rules, ...rest } = props;
    const { control } = useFormContext();

    const renderField = useMemo(() => fieldFactory({ ...props }, ref), [props, ref]);

    return (
      <Controller
        name={rest.name}
        rules={rules}
        shouldUnregister={rules?.shouldUnregister}
        control={control}
        render={renderField}
      />
    );
  }
);

/**
 * In order to be able to use react hooks without breaking
 * the rule of hooks, had to extract the render into a component.
 * This is to ensure correctness of the react-hook-form integration.
 **/
const fieldFactory = (
  props: TextDropdownMultiRhfProps,
  ref?: ForwardedRef<HTMLDivElement>
) => {
  return (fieldProps: FieldProps) => {
    const mergedRefs = useMergeRefs([fieldProps.field.ref, ref]);
    const textDropdownMultiProps = useTextDropdownMultiRhf({ ...props, fieldProps });
    return <TextDropdownMulti ref={mergedRefs} {...textDropdownMultiProps} />;
  };
};
